import React, { useEffect, useState } from 'react';

import { useLocation } from 'react-router-dom';
import jsPDF from 'jspdf';
import html2canvas from "html2canvas";

import NavBarPikuahBniaItems from './NavBarPikuahBniaItems';
import PikuahInfo from './PikuahInfo';
// import ProcessInfo from '../RishuiBnia/ProcessInfo';
import ProcessInfoContainer from '../RishuiBnia/ProcessInfoContainer';
import LocationInfo from '../RishuiBnia/LocationInfo';
import BakashalInfo from '../RishuiBnia/BakashalInfo';
import PageBar from '../../CustomeComponents/PageBar';
import { getTikPikuahType } from '../../server/ServerFunc';


const NavBarPikuahBniaContainer = (props) => {
    const [pikuahBniaObj, setPikuahBniaObj] = useState({});
    const [componentName, setComponentName] = useState("");
    const [compDate, setCompDate] = useState("");
    const [compTitle, setCompTitle] = useState("");
    const search = useLocation().search;

    useEffect(() => {
        const compName = new URLSearchParams(search).get("Page");
        let title = ""
        if(compName === "PikuahInfo") {
            title = "אישורים בתיק פיקוח";
        } else if(compName === "ProcessInfo") {
            title = "תהליך טיפול בתיק";
        } else if (compName === "LocationInfo") {
            title = "נתוני מיקום";
        } else {
            title = "תיאור הבקשה";
        }

        const date = new Date();
        const year = date.getFullYear();
        const month = date.getMonth() + 1;
        const day = date.getDate();
        setComponentName(compName);
        setCompTitle(title);
        setCompDate(`${day}/${month}/${year}`);
    }, []);

    useEffect(() => {
        if(props.pageEvent === "Header") {
            window.location.reload();
        }
    }, [props]);

    useEffect(() => {
        const tikNumURL = new URLSearchParams(search).get("TikNum");
        getType(tikNumURL);
    }, []);

    const getType = async (tikPikuahNum) => {
        let typeRes = await getTikPikuahType(tikPikuahNum);
        if (Object.keys(typeRes).length > 0) {
            setPikuahBniaObj(typeRes[0]);
        }
    }

    const renderComponent = (compName) => {
        let componentToRender;
        if(pikuahBniaObj.tikCode === 111000010) {
            switch (compName) {
                case "PikuahInfo":
                    componentToRender = <PikuahInfo isSeparate={false} />
                    break;
                case "ProcessInfo":
                    // componentToRender = <ProcessInfo />;
                    componentToRender = <ProcessInfoContainer isSeparate={false} />;
                    break;
                case "LocationInfo": 
                    componentToRender = <LocationInfo isSeparate={false} />; 
                    break;
                case "BakashalInfo":
                    componentToRender = <BakashalInfo isSeparate={false} />;
                    break;
                default:
                    componentToRender = <div>אדם חכם אמר פעם: "לעולם אל תסמוך על דף שאינך יכול למצוא"</div>
                    break;
            }
        } else {
            switch (compName) {
                case "PikuahInfo":
                    componentToRender = <PikuahInfo isSeparate={false} />
                    break;
                case "ProcessInfo":
                    // componentToRender = <ProcessInfo />;
                    componentToRender = <ProcessInfoContainer isSeparate={false} />;
                    break;
                case "LocationInfo": 
                    componentToRender = <LocationInfo isSeparate={false} />; 
                    break;
                default:
                    componentToRender = <div>אדם חכם אמר פעם: "לעולם אל תסמוך על דף שאינך יכול למצוא"</div>
                    break;
            }
        }
        
        return componentToRender;
    }

    const changeComponent = (name) => {
        setComponentName(name);
    }

    // const print = () => {
    //     const tikData = document.getElementById("tikToPrint");
    //     html2canvas(tikData).then((canvas) => {            
    //         // height: 1792 ,width: 585
    //         const imgWidth = 180;
    //         // const imgWidth = 180;
    //         // const pageHeight = 295;
    //         const imgHeight = (canvas.height * imgWidth) / canvas.width;
    //         // let heightLeft = imgHeight;
    //         let positionY = 10;
    //         // heightLeft -= pageHeight;

    //         const pdf = new jsPDF("p", "mm");
    //         pdf.addImage(canvas, "JPEG", 10, positionY, imgWidth , imgHeight - 5, "", "FAST");

    //         pdf.save(`test_`);
    //     });
    // }

    const SugTikPikuah = () => {
        return (
            <div id="tikToPrint">
                <PageBar className="container my-3" >
                    {/* <div className="d-flex gap-4" id="tikToPrint"> */}
                    <div className="d-flex gap-4" style={{ margin: "10px 0px", fontSize: "larger"}}>
                        <span>
                            <span><b>תיק: </b></span>
                            <span>{`${pikuahBniaObj.tikNum}`}</span>
                        </span>
                        <span>
                            <span><b>סוג תיק: </b></span>
                            <span>{`${pikuahBniaObj.sugTikPikuah}`}</span>
                        </span>
                        <span style={{ zIndex: -1 }}>
                            <span><b>, </b></span>
                            <span>{compTitle}, </span>
                        </span>
                        <span style={{ zIndex: -1 }}>
                            <span><b>תאריך: </b></span>
                            <span>{compDate}</span>
                        </span>
                    </div>
                    {/* <button onClick={print}>
                        print
                    </button> */}
                    {/* </div> */}
                </PageBar>
            </div>
        )
    }

    return (
        <>
            <NavBarPikuahBniaItems componentName={componentName} tikCode={pikuahBniaObj.tikCode} changeComponent={changeComponent}/>
            <div className="container my-3 my-lg-5">
                <SugTikPikuah />
                {renderComponent(componentName)}
            </div>
        </>
    )
}

export default NavBarPikuahBniaContainer